import React from "react";
import { HashLink } from "react-router-hash-link";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";

const FullAnesthesiaImplant = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  const page = t("fullAnesthesiaImplant.page", { returnObjects: true });
  const sections = page.sections;
  const faq = t("fullAnesthesiaImplant.page.faq", { returnObjects: true });

  return (
    <div className="container py-5 mt-5" dir={lang === "ar" ? "rtl" : "ltr"}>
      <Helmet>
        <link
          rel="canonical"
          href="https://saleemsmile.com/articles/full-anesthesia-implant"
        />

        <title>{t("fullAnesthesiaImplant.seo.title")}</title>
        <meta
          name="description"
          content={t("fullAnesthesiaImplant.seo.description")}
        />
        <meta
          name="keywords"
          content={t("fullAnesthesiaImplant.seo.keywords")}
        />
        <meta
          property="og:title"
          content={t("fullAnesthesiaImplant.seo.ogTitle")}
        />
        <meta
          property="og:description"
          content={t("fullAnesthesiaImplant.seo.ogDescription")}
        />
        <meta
          property="og:image"
          content="https://via.placeholder.com/800x450.png?text=Full+Anesthesia+Dental+Implants"
        />
        <meta property="og:type" content="article" />
        <meta
          property="og:locale"
          content={lang === "ar" ? "ar_AR" : "en_US"}
        />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faq.map((item) => ({
              "@type": "Question",
              name: item.question,
              acceptedAnswer: { "@type": "Answer", text: item.answer },
            })),
          })}
        </script>
      </Helmet>

      <h1 className="mb-4 text-center" style={{ color: "#00b3ff" }}>
        {page.title}
      </h1>
      <h5 className="text-center mb-5">{page.subtitle}</h5>
      <p className="text-center">{page.intro}</p>
      <p className="text-center text-muted">{page.description}</p>

      <h2 className="mt-4">{sections.whoTitle}</h2>
      <ul>
        {sections.whoList.map((item, idx) => (
          <li key={idx}>{item}</li>
        ))}
      </ul>

      <h2 className="mt-4">{sections.benefitsTitle}</h2>
      <ul>
        {sections.benefitsList.map((item, idx) => (
          <li key={idx}>{item}</li>
        ))}
      </ul>

      <h2 className="mt-4">{sections.hospitalsTitle}</h2>
      <p>{sections.hospitalsText}</p>

      <h2 className="mt-4">{sections.stepsTitle}</h2>
      <ol>
        {sections.stepsList.map((item, idx) => (
          <li key={idx}>{item}</li>
        ))}
      </ol>

      <h2 className="mt-4">{sections.whyChooseTitle}</h2>
      <ul>
        {sections.whyChooseList.map((item, idx) => (
          <li key={idx}>{item}</li>
        ))}
      </ul>

      <footer className="mt-4">
        <HashLink to="/#services" className="btn btn-outline-secondary">
          {sections.backButton}
        </HashLink>
      </footer>
    </div>
  );
};

export default FullAnesthesiaImplant;
